import { FilterSearch } from '../filter-search.model';

export class FreightExchangeListFilters {
  public static filterSearch: FilterSearch = {
    filter: null,
    filterSearchValue: '',
  };
}
